import React, { useEffect, useState } from 'react';
import { toast } from 'react-hot-toast';
import { MENU_GROUPS, MenuItem } from '../config/menu';
import menueService from '../services/menueService';
import { Icon, PageHeader, LoadingScreen } from '../components/ui';

const MenueKonfiguration: React.FC = () => {
  const [sichtbarkeit, setSichtbarkeit] = useState<Record<string, boolean>>({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    menueService.getSichtbarkeit()
      .then(setSichtbarkeit)
      .catch(() => toast.error('Sichtbarkeit konnte nicht geladen werden'))
      .finally(() => setLoading(false));
  }, []);

  const istAn = (key: string) => sichtbarkeit[key] !== false;

  const toggle = async (key: string) => {
    const neu = !istAn(key);
    setSichtbarkeit((prev) => ({ ...prev, [key]: neu }));   // optimistisch
    try {
      await menueService.setSichtbarkeit(key, neu);
      toast.success(neu ? 'Menüpunkt eingeblendet' : 'Menüpunkt ausgeblendet');
    } catch {
      setSichtbarkeit((prev) => ({ ...prev, [key]: !neu })); // revert
      toast.error('Sichtbarkeit konnte nicht gespeichert werden');
    }
  };

  const zeile = (item: MenuItem, unterpunkt: boolean) => {
    const an = istAn(item.key);
    return (
      <div key={item.key} className={`flex items-center justify-between py-3 pr-4 ${unterpunkt ? 'pl-12' : 'pl-4'}`}>
        <div className="flex items-center gap-3">
          <span className="text-gray-500">{React.createElement(Icon[item.icon], { className: 'h-5 w-5' })}</span>
          <div>
            <p className="text-sm font-medium text-gray-900">{item.label}</p>
            {unterpunkt && <span className="text-xs text-gray-500">Unterpunkt, nur im Bereich sichtbar</span>}
            {item.adminOnly && <span className="text-xs text-purple-600">nur Admins</span>}
          </div>
        </div>
        {item.alwaysVisible ? (
          <span className="text-xs text-gray-400">immer sichtbar</span>
        ) : (
          <button
            role="switch"
            aria-checked={an}
            onClick={() => toggle(item.key)}
            className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${an ? 'bg-brand-600' : 'bg-gray-300'}`}
          >
            <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${an ? 'translate-x-6' : 'translate-x-1'}`} />
          </button>
        )}
      </div>
    );
  };

  return (
    <div className="p-4 md:p-6">
      <PageHeader title="Menü-Konfiguration" subtitle="Menüpunkte für alle Nutzer ein- oder ausblenden." />

      {loading ? (
        <LoadingScreen />
      ) : (
        <div className="space-y-4 max-w-2xl">
          {MENU_GROUPS.map((group) => (
            <div key={group.key} className="bg-white rounded-lg shadow">
              <h2 className="text-sm font-semibold text-gray-700 px-4 pt-4 pb-2">{group.label}</h2>
              <div className="divide-y divide-gray-100">
                {group.items.flatMap((item) => [
                  zeile(item, false),
                  ...(item.unterpunkte || []).map((u) => zeile(u, true)),
                ])}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MenueKonfiguration;
